export default __webpack_public_path__ + "static/media/MOQ.8636f8cc.jpeg";